import { Crown, X, Sparkles, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Paywall({ open, onClose, title, message, ctaText = "Vedi piani" }) {
  const navigate = useNavigate();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-app/85 backdrop-blur-md flex items-center justify-center p-4 animate-fade-up" onClick={onClose}>
      <div
        className="bg-surface border border-brand/30 rounded-3xl max-w-md w-full p-7 relative"
        onClick={(e) => e.stopPropagation()}
        data-testid="paywall-modal"
      >
        <button onClick={onClose} className="absolute top-4 right-4 p-2 rounded-full hover:bg-elevated text-tertiary-fg" data-testid="paywall-close">
          <X className="w-4 h-4" />
        </button>
        <div className="w-14 h-14 rounded-2xl bg-brand grid place-items-center mb-4">
          <Crown className="w-7 h-7 text-white" strokeWidth={1.5} />
        </div>
        <h3 className="font-display text-2xl font-semibold tracking-tight">{title || "Sblocca il piano Standard"}</h3>
        <p className="text-secondary-fg text-sm mt-3 leading-relaxed">
          {message || "La tua famiglia merita una memoria senza limiti. Passa a Standard e continua a costruire ricordi."}
        </p>

        <div className="mt-5 grid grid-cols-2 gap-2">
          <div className="bg-elevated rounded-2xl p-3">
            <div className="text-xs text-tertiary-fg">Standard</div>
            <div className="font-display text-2xl font-semibold mt-1">€4.99<span className="text-xs text-tertiary-fg ml-1">/mese</span></div>
          </div>
          <div className="bg-elevated rounded-2xl p-3 border border-amber-warm/30">
            <div className="text-xs text-amber-warm flex items-center gap-1"><Sparkles className="w-3 h-3" /> Premium</div>
            <div className="font-display text-2xl font-semibold mt-1">€15.99<span className="text-xs text-tertiary-fg ml-1">/mese</span></div>
          </div>
        </div>

        <button
          onClick={() => { onClose(); navigate("/pricing"); }}
          data-testid="paywall-cta"
          className="btn-primary w-full mt-5 flex items-center justify-center gap-2"
        >
          {ctaText} <ArrowRight className="w-4 h-4" />
        </button>
        <button
          onClick={onClose}
          data-testid="paywall-dismiss"
          className="w-full mt-2 py-2 text-tertiary-fg hover:text-primary-fg text-sm"
        >
          Non ora
        </button>
      </div>
    </div>
  );
}
